module.exports = __webpack_public_path__ + "img/envelope4.da9a5777.jpg";